/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2014-2017, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */
'use strict';

/**
 * A directive for the perfect-scrollbar plugin.
 * https://github.com/noraesae/perfect-scrollbar
 * Code borrowed from https://github.com/itsdrewmiller/angular-perfect-scrollbar
 */
angular.module('bulbApp.utilsModule')

.directive('bulbThemedScrollbar', ['$interval','$parse','$timeout', bulbThemedScrollbar]);

function bulbThemedScrollbar($interval, $parse, $timeout) {
  var directiveDefinitionObject = {
    restrict: 'A',
    transclude: true,
    template: '<div><div class="bulb-scroll-content" ng-transclude></div></div>',
    link: function(scope, elem, attr) {

      var domElement = elem.get(0);

      var isBulbThemedScrollbarActive = parseBulbThemedScrollbarAttr(attr.bulbThemedScrollbar);
      if (isBulbThemedScrollbarActive) {
        addScrollbar(domElement, attr);
      }

      scope.$watch(attr.bulbThemedScrollbar, function() {
        if (parseBulbThemedScrollbarAttr(attr.bulbThemedScrollbar) !== isBulbThemedScrollbarActive) {
          isBulbThemedScrollbarActive = !isBulbThemedScrollbarActive;
          if (isBulbThemedScrollbarActive) {
            addScrollbar(domElement, attr);
          } else {
            window.Ps.destroy(domElement);
          }
        }
      });

      if (attr.refreshOnChange) {
        scope.$watchCollection(attr.refreshOnChange, function () {
          if (isBulbThemedScrollbarActive) {
            scope.$evalAsync(function () {
              window.Ps.update(domElement);
            });
          }
        });
      }

      if (attr.observingContentSize) {
        scope.$watch(function() {
          var content = jQuery(domElement).find('.bulb-scroll-content').eq(0);
          return content.width() + ' ' + content.height();
        }, function () {
          if (isBulbThemedScrollbarActive) {
            scope.$evalAsync(function () {
              window.Ps.update(domElement);
            });
          }
        });
      }

      /** 
      *  Callback function for handling mousenter event.
      */
      elem.bind('mouseenter', function () {
        window.Ps.update(domElement);
      });

      elem.bind('$destroy', function () {
        if (isBulbThemedScrollbarActive) {
          window.Ps.destroy(domElement);
        }
      });
    }
  };

  function parseBulbThemedScrollbarAttr(attrValue) {
    // Blank, undefined, or true resolve to true; any other value resolves to false
    return (attrValue === '' || typeof attrValue === 'undefined' || attrValue === 'true');
  }

    function addScrollbar(domElement, attr) {
    jQuery(domElement).addClass('ps-container');
    var perfectScrollbarOptions = {};
    [
      'wheelSpeed', 'wheelPropagation', 'minScrollbarLength', 'useBothWheelAxes',
      'useKeyboard', 'suppressScrollX', 'suppressScrollY', 'scrollXMarginOffset',
      'scrollYMarginOffset', 'includePadding'
    ].forEach(function(psOption) {
      if (attr[psOption] !== undefined) {
        perfectScrollbarOptions[psOption] = $parse(attr[psOption])();
      }
    });
    window.Ps.initialize(domElement, perfectScrollbarOptions);
    // show scroll bar
    $timeout(function(){
      window.Ps.update(domElement);
      var counter = 0;
      //Adding the role as Scrollbar for Vertical bar
      var watchForRenderFinish = $interval(function() {
        if (counter < 20) {
          counter++;
          var verticalScrollbar = jQuery('.ps__scrollbar-y');
          if (verticalScrollbar !== undefined) {
            verticalScrollbar.attr('role', 'scrollbar');
            verticalScrollbar.attr('aria-valuenow', '0');
            $interval.cancel(watchForRenderFinish);
          }
        } else if (counter >= 20) {
          $interval.cancel(watchForRenderFinish);
        }
      }, 100);
    }, 1);
    }

  return directiveDefinitionObject;
}
